import { CREDIT_NOTE_ITEM_TYPES, CreditNoteItemType } from "consts";

import { GetPendingPaymentsResponseBody } from "models";

type PendingPaymentWithDetails = GetPendingPaymentsResponseBody["withBankingDetails"][number];

// Assigns one credit note number per farm with at least one nonzero payment type, in payment order.
// This must be the single source of truth for the mapping: both the downloaded CSV and the
// processPayments request need to reference the exact same farmId -> credit note number pairs.
export const assignCreditNoteNumbers = (
  payments: PendingPaymentWithDetails[],
  latestCreditNoteNumber: number,
  itemTypes: readonly CreditNoteItemType[] = CREDIT_NOTE_ITEM_TYPES
): Record<string, number> => {
  let runningCreditNoteNumber = latestCreditNoteNumber;

  return payments.reduce<Record<string, number>>((assignments, payment) => {
    const hasNonZeroPayment = itemTypes.some(({ netField }) => !!payment[netField]);

    if (!hasNonZeroPayment) return assignments;

    runningCreditNoteNumber += 1;
    assignments[payment.farmId] = runningCreditNoteNumber;

    return assignments;
  }, {});
};
